import { formatDonorFeedLine } from '@/lib/recent-donor-feed';
import { useRecentDonorFeed } from '@/lib/use-recent-donor-feed';

export function DonorWallPreview(): JSX.Element {
  const { entries, loading } = useRecentDonorFeed(6, 'DonorWallPreview');

  return (
    <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
      <p className="text-xs font-bold uppercase tracking-wide text-blue-700">Recent Warriors</p>
      {loading ? (
        <p className="mt-2 text-sm text-gray-500">Loading recent gifts…</p>
      ) : entries.length === 0 ? (
        <p className="mt-2 text-sm text-gray-600">Your name could be next on the donor wall.</p>
      ) : (
        <ul className="mt-2 space-y-1.5 text-sm text-gray-800">
          {entries.map((entry) => (
            <li key={entry.id} className="truncate">
              {formatDonorFeedLine(entry)}
            </li>
          ))}
        </ul>
      )}
      <p className="mt-3 text-xs font-medium text-blue-700 italic">Your name could be next.</p>
    </div>
  );
}
